import { createSlice } from "@reduxjs/toolkit";
import { configManager } from "../utils/ConfigManager";

const initialState = {
	module: "",
};

export const moduleSlice = createSlice({
	name: "module",
	initialState,
	reducers: {
		setModule: (state, action) => {
			state.module = action.payload;
			localStorage.setItem(configManager.getConfig("localStorageModule"), action.payload);
		},
		unsetModule: (state) => {
			state.module = "";
			localStorage.removeItem(configManager.getConfig("localStorageModule"));
		},
	},
});

export const { setModule, unsetModule } = moduleSlice.actions;

export default moduleSlice.reducer;
